import { render, staticRenderFns } from "./resolve_discussion_button.vue?vue&type=template&id=68f931c5&vue3"
import script from "./resolve_discussion_button.vue?vue&type=script&lang=js&vue3"
export * from "./resolve_discussion_button.vue?vue&type=script&lang=js&vue3"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports